import { Events } from "../../../thor.enums";
import { FileAccept } from "../../../typings/common";

export class AddItemController {
    public static $inject: string[] = [
        "$log",
        "$mdDialog",
        "$mdMedia",
        "$scope",
        "$translate",
        "toaster",
        "utilsService"
    ];

    // Binded
    public sale;

    protected isOpen: boolean = false;
    protected $t;

    constructor(
        protected $log: ng.ILogService,
        protected $mdDialog: ng.material.IDialogService,
        protected $mdMedia: ng.material.IMedia,
        protected $scope: ng.IScope,
        $translate: ng.translate.ITranslateService,
        protected toaster,
        protected utils
    ) {
        this.$t = $translate.instant;
    }

    public $onInit() {
        this.$scope.$on(Events.ImportFile, (event, { file, fileType }) => {
            this.$log.info("AddItemController::$onInit::$scope.$on", file, fileType);

            switch (fileType) {
                case FileAccept.CSV:
                    return this.selectCsvSaleItemsFile(event, file);
                case FileAccept.PV2:
                    return this.selectPasserelleFile(event, file);
                case FileAccept.Image:
                    return this.selectMediasFiles(event, Array.from(file));
            }
        });
    }

    public selectPasserelleFile(event, file) {
        if (!file || !file.name) {
            return;
        }

        const extension = this.utils.getFileExtension(file.name);
        let engineType;

        if (extension === "zip") {
            engineType = "zipPasserelle";
        }

        if (extension === "xml") {
            engineType = "xmlPasserelle";
        }

        if (engineType) {
            this._createUploadDialog(event, file, engineType);
        }
    }

    public selectMediasFiles(event, files) {
        if (files.length < 1) {
            return;
        }

        this._createUploadDialog(event, files, "medias");
    }

    public selectCsvSaleItemsFile(event, file) {
        if (!file || !file.name) {
            return;
        }

        this._createUploadDialog(event, file, "csvSaleItems");
    }

    public selectCsvSaleResultsFile(event, file) {
        if (!file || !file.name) {
            return;
        }

        this._createUploadDialog(event, file, "csvSaleResult");
    }

    protected createNewItemDialog() {
        this.$mdDialog.show({
            controller: "NewItemDialogController",
            controllerAs: "newItemDialogCtrl",
            template: require("./new-item-dialog.html"),
            locals: {
                sale: this.sale
            },
            bindToController: true,
            fullscreen: this.$mdMedia("xs")
        });
    }

    protected _createUploadDialog(event, data, engineType) {
        this.$mdDialog.show({
            controller: "ImportDialogController",
            controllerAs: "importDialogCtrl",
            template: require("./import-dialog.html"),
            locals: {
                sale: this.sale,
                engineData: data,
                engineType: engineType
            },
            bindToController: true,
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            fullscreen: this.$mdMedia("xs")
        });
    }
}
